import React, {useEffect, useState} from "react";
import DashboardPanel from "../../../components/DashboardPanel";
import {withWarehousePackages} from "../../../lib/WarehouseHelper";
import OrderWithPackages from "./OrderWithPackages";


const Panel = (props) => {
  const {
    warehouseId, packages,
    getJobById, getAlertInfoForJobId,
  } = props;

  // Packages are grouped by jobId (for display purpose only)
  const [orders, setOrders] = useState({});

  useEffect(() => {
    setOrders(packages.reduce((acc, p) => {
      const jobId = p.get("jobId");

      if (!acc[jobId]) {
        // Init order info
        acc[jobId] = {
          ...getJobById(jobId),
          id: jobId, // keep in mind as the acc keys will be thrown away
          packages: [],
          alert: getAlertInfoForJobId(jobId),
        }
      }

      acc[jobId].packages.push(p);

      return acc;
    }, {}));
  }, [packages, getJobById, getAlertInfoForJobId]);

  return (
    <DashboardPanel title="Loaded / With Courier" theme="loaded" comment="Jobs will automatically be marked as fulfilled.">
      { Object.values(orders).map((o) => <OrderWithPackages key={o.id} {...o} warehouseId={warehouseId} />) }
    </DashboardPanel>
  );
}

export default withWarehousePackages(Panel);